import { render, staticRenderFns } from "./FormRF07.vue?vue&type=template&id=f6d45a7c&scoped=true&"
import script from "./FormRF07.vue?vue&type=script&lang=js&"
export * from "./FormRF07.vue?vue&type=script&lang=js&"
import style0 from "./FormRF07.vue?vue&type=style&index=0&id=f6d45a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d45a7c",
  null
  
)

export default component.exports